import {
  DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  DESK_DEFAULT_SPACE_GALLERY,
  DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  DESK_DEFAULT_COUNT_ROWS,
  DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  MOBILE_DEFAULT_COUNT_ROWS,
} from './proGalleryConstants';
import { getDefaultLang } from '../actions/more/langHelperFunctions';
import {
  PROFILE_LAYOUT_POSITIN,
  FEED_LAYOUT_POSITIN,
  HASHTAG_LAYOUT_POSITIN,
  M_FEED_LAYOUT_POSITIN,
  M_HASHTAG_LAYOUT_POSITIN,
  M_PROFILE_LAYOUT_POSITIN,
  DEFAULT_AVATAR_SIZE_DESKTOP,
} from './index';

export const DESK_FEED_MAX_SPACING = 100;
export const DESK_FEED_MAX_GALLERY_SPACING = 20;
export const DESK_FEED_GRID_MAX_ROWS = 8;
export const DESK_FEED_GRID_MAX_COLUMNS = 8;
export const DESK_FEED_SLIDER_MAX_COLUMNS = 8;

export const LAYOUTS = {
  GRID: 1,
  SLIDER: 2,
  COLLAGE: 3,
};

// Thumbnails
export const LAYOUT_PROFILE = {
  CLASSIC: 0,
  CENTER: 1,
};
export const ALIGNMENT = {
  CENTER: 1,
  LEFT: 0,
};
export const RATIO = {
  OPTION1: 16 / 9,
  OPTION2: 4 / 3,
  OPTION3: 1 / 1,
  OPTION4: 3 / 4,
  OPTION5: 9 / 16,
};
export const PROFILE_PICTURE_RADIUS = {
  CIRCLE: 50,
  ROUND: 10,
  SQUARE: 0.1,
};
export const DIRECTIONS = {
  LTR: 0,
  RTL: 1,
};
export const CLICKING_ON_ITEM_OPTIONS = {
  OPEN_EXPAND: 1,
  OPEN_LINK: 2,
  NOTHING_APPENED: 3,
};

export const CLICKING_ON_AVATAR_OPTIONS = {
  OPEN_STORY: 1,
  OPEN_ACCOUNT: 2,
  NOTHING_APPENED: 3,
};

export const SORT_HASHTAG_OPTIONS = {
  MOST_RECENT: 1,
  MOST_VIEWED: 2,
};

export const HASHTAG_TITLE_OPTIONS = {
  HASHTAGS: 1,
  CUSTOM: 2,
  NOTHING: 3,
};

export const DISPLAY_ON_HOVER = {
  COUNTERS: 0,
  CAPTIONS: 1,
};

export const COLLAGE_POST_SIZE = {
  XSMALL: 0,
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
};

export const MOBILE_COLLAGE_POST_SIZE = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2,
};

export const MOBILE_BIO_DISPLAY_OPTIONS = {
  SEE_MORE_BTN: 0,
  BIO: 1,
};

export const OVERLAY_EFFECTS = {
  NO_EFFECTS: 0,
  FADE_IN: 1,
};

export const IMAGE_HOVER_EFFECTS = {
  NO_EFFECTS: 0,
  ZOOM_IN: 1,
  GRAYSCALE: 2,
  COLOR_IN: 3,
};

export const BOOLEANS = {
  isDisplayProfileInfo: true,
  isDisplayProfilePicture: true,
  isDisplayTitle: true,
  isDisplayPostsCount: true,
  isDisplayFollowersCount: true,
  isDisplayFollowingCount: true,
  isDisplayProfileBio: true,
  isDisplayFollowBtn: true,
  isDisplayImagesFeed: true,
  isDisplayHashtagsFeed: true,
  isHoverPost: true,
  isShowMoreBtn: true,
  isShowMoreBtnCollage: true,
  isShowMoreBtnCollageHashtag: true,
  isShowMoreBtnHashtag: true,
  isSlideAutomatically: false,
  isSlideAutomaticallyHashtag: false,
  isLoopImages: false,
  isLoopImagesHashtag: false,
  isHoverMode: false,
  m_isDisplayImagesFeed: true,
  m_isShowMoreBtn: true,
  m_isShowMoreBtnHashtag: true,
  m_isDisplayProfileInfo: true,
  m_isDisplayProfilePicture: true,
  m_isDisplayPostsCount: true,
  m_isDisplayFollowersCount: true,
  m_isDisplayFollowingCount: true,
  m_isDisplayFollowBtn: true,
  m_isDisplayHashtagsFeed: true,
  m_isDisplayTitlesHashtag: true,
  m_isShowMoreBtnCollageHashtag: true,
  m_isShowMoreBtnCollage: true,
  e_isDisplayCaption: true,
  e_isStoryAutoplaySoundOn: true,
  e_isDisplayCounters: true,
  e_isDisplayComments: true,
  e_isDisplayTimestamp: true,
};

export const NUMBERS = {
  ratio: RATIO.OPTION3,
  clickingOnProfilePicture: CLICKING_ON_AVATAR_OPTIONS.NOTHING_APPENED,
  clickingOnItem: 1,
  sortHashtagsFeed: SORT_HASHTAG_OPTIONS.MOST_VIEWED,
  hashtagTitle: HASHTAG_TITLE_OPTIONS.HASHTAGS,
  layoutType: LAYOUTS.GRID,
  galleryLayoutHashtag: LAYOUTS.SLIDER,
  numberOfRowsGrid: DESK_DEFAULT_COUNT_ROWS,
  numberOfRowsGridHashtag: DESK_DEFAULT_COUNT_ROWS,
  numberOfColumnsGrid: DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  numberOfColumnsGridHashtag: DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  spacingGrid: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  gallerySpacingGrid: DESK_DEFAULT_SPACE_GALLERY,
  gallerySpacingGridHashtag: DESK_DEFAULT_SPACE_GALLERY,
  m_gallerySpacingGridHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  gallerySpacingCollage: DESK_DEFAULT_SPACE_GALLERY,
  gallerySpacingCollageHashtag: DESK_DEFAULT_SPACE_GALLERY,
  gallerySpacingSlider: DESK_DEFAULT_SPACE_GALLERY,
  gallerySpacingSliderHashtag: DESK_DEFAULT_SPACE_GALLERY,
  m_gallerySpacingGrid: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  spacingCollage: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  spacingItemsCollageHashtag: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  spacingItemsGridHashtag: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  rowsLoadMoreGrid: DESK_DEFAULT_COUNT_ROWS,
  numberOfColumnsSlider: DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  numberOfColumnsSliderHashtag: DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  spacingSlider: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  spacingItemsSliderHashtag: DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  headerLayout: LAYOUT_PROFILE.CLASSIC,
  [PROFILE_LAYOUT_POSITIN]: 0,
  [FEED_LAYOUT_POSITIN]: 1,
  [HASHTAG_LAYOUT_POSITIN]: 2,
  [M_PROFILE_LAYOUT_POSITIN]: 0,
  [M_FEED_LAYOUT_POSITIN]: 1,
  [M_HASHTAG_LAYOUT_POSITIN]: 2,
  profilePictureSize: DEFAULT_AVATAR_SIZE_DESKTOP,
  direction: DIRECTIONS.LTR,
  overlayEffect: OVERLAY_EFFECTS.FADE_IN,
  imageHoverEffect: IMAGE_HOVER_EFFECTS.NO_EFFECTS,
  displayOnHover: DISPLAY_ON_HOVER.CAPTIONS,
  collagePostSize: COLLAGE_POST_SIZE.LARGE,
  collagePostSizeHashtag: COLLAGE_POST_SIZE.LARGE,
  hashtagLayout: ALIGNMENT.CENTER,
  rowsLoadMoreCollage: 1,
  rowsLoadMoreCollageHashtag: 1,
  m_gallerySpacingCollage: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_gallerySpacingCollageHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_gallerySpacingSlider: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_gallerySpacingSliderHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_rowsLoadMoreCollageHashtag: 1,
  m_rowsLoadMoreCollage: 1,
  m_spacingItemsGridHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_spacingItemsGrid: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_numberOfColumnsGrid: MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  m_numberOfRowsGrid: MOBILE_DEFAULT_COUNT_ROWS,
  m_spacingItemsSlider: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_numberOfColumnsSlider: MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  m_numberOfColumnsGridHashtag: MOBILE_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  m_numberOfRowsGridHashtag: MOBILE_DEFAULT_COUNT_ROWS,
  m_spacingItemsSliderHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_numberOfColumnsSliderHashtag: MOBILE_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  m_displayBio: MOBILE_BIO_DISPLAY_OPTIONS.SEE_MORE_BTN,
  m_headerLayout: LAYOUT_PROFILE.CLASSIC,
  mobileShowMoreFontSize: 14,
  m_spacingItemsCollage: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_spacingItemsCollageHashtag: MOBILE_DEFAULT_SPACE_BETWEEN_ITEMS,
  m_collagePostSizeHashtag: MOBILE_COLLAGE_POST_SIZE.LARGE,
  m_collagePostSize: MOBILE_COLLAGE_POST_SIZE.LARGE,
  m_galleryLayout: LAYOUTS.GRID,
  m_galleryLayoutHashtag: LAYOUTS.SLIDER,
  langPicker: getDefaultLang(),
};

export const STYLE_PARAMS_BY_LAYOUTS = {
  GLOBAL: [
    'itemBorderWidth',
    'itemBorderColor',
    'cornerRadiusFeed',
    'overlayEffect',
    'imageHoverEffect',
  ],
  GRID: {
    DESK: [
      'spacingGrid',
      'gallerySpacingGrid',
      'numberOfColumnsGrid',
      'numberOfRowsGrid',
      'isShowMoreBtn',
      'ratio',
      'direction',
    ],
    MOBILE: [
      'm_spacingItemsGrid',
      'm_gallerySpacingGrid',
      'm_numberOfColumnsGrid',
      'm_numberOfRowsGrid',
      'm_isShowMoreBtn',
      'direction',
    ],
  },
  COLLAGE: {
    DESK: [
      'gallerySpacingCollage',
      'spacingCollage',
      'collagePostSize',
      'isShowMoreBtnCollage',
      'rowsLoadMoreCollage',
      'direction',
    ],
    MOBILE: [
      'm_gallerySpacingCollage',
      'm_collagePostSize',
      'm_spacingItemsCollage',
      'm_isShowMoreBtnCollage',
      'm_rowsLoadMoreCollage',
      'direction',
    ],
  },
  SLIDER: {
    DESK: [
      'gallerySpacingSlider',
      'isLoopImages',
      'isSlideAutomatically',
      'spacingSlider',
      'direction',
      'numberOfColumnsSlider',
      'sliderArrowsPadding',
      'sliderArrowsPosition',
      'sliderArrowsSize',
    ],
    MOBILE: [
      'm_gallerySpacingSlider',
      'isLoopImages',
      'isSlideAutomatically',
      'direction',
      'm_spacingItemsSlider',
      'm_numberOfColumnsSlider',
      'm_sliderArrowsPadding',
      'm_sliderArrowsPosition',
      'm_sliderArrowsSize',
    ],
  },
};

export const STYLE_PARAMS_BY_LAYOUTS_HASHTAG = {
  GLOBAL: [
    'itemBorderWidth',
    'itemBorderColor',
    'cornerRadiusHashtag',
    'overlayEffect',
    'imageHoverEffect',
  ],
  GRID: {
    DESK: [
      'gallerySpacingGridHashtag',
      'spacingItemsGridHashtag',
      'numberOfColumnsGridHashtag',
      'numberOfRowsGridHashtag',
      'isShowMoreBtnHashtag',
      'direction',
    ],
    MOBILE: [
      'm_gallerySpacingGridHashtag',
      'm_spacingItemsGridHashtag',
      'm_numberOfColumnsGridHashtag',
      'm_numberOfRowsGridHashtag',
      'm_isShowMoreBtnHashtag',
      'direction',
    ],
  },
  COLLAGE: {
    DESK: [
      'gallerySpacingCollageHashtag',
      'spacingItemsCollageHashtag',
      'collagePostSizeHashtag',
      'isShowMoreBtnCollageHashtag',
      'rowsLoadMoreCollageHashtag',
      'direction',
    ],
    MOBILE: [
      'm_gallerySpacingCollageHashtag',
      'm_spacingItemsCollageHashtag',
      'm_collagePostSizeHashtag',
      'm_isShowMoreBtnCollageHashtag',
      'm_rowsLoadMoreCollageHashtag',
      'direction',
    ],
  },
  SLIDER: {
    DESK: [
      'gallerySpacingSliderHashtag',
      'isLoopImagesHashtag',
      'isSlideAutomaticallyHashtag',
      'spacingItemsSliderHashtag',
      'direction',
      'numberOfColumnsSliderHashtag',
      'sliderArrowsPadding',
      'sliderArrowsPosition',
      'sliderArrowsSize',
    ],
    MOBILE: [
      'm_gallerySpacingSliderHashtag',
      'isLoopImagesHashtag',
      'isSlideAutomaticallyHashtag',
      'direction',
      'm_spacingItemsSliderHashtag',
      'm_numberOfColumnsSliderHashtag',
      'm_sliderArrowsPadding',
      'm_sliderArrowsPosition',
      'm_sliderArrowsSize',
    ],
  },
};
